export default "__VITE_ASSET__Bz30Y6Cv__"